import { createContext } from "react";

export const StripeCustomerContext = createContext();
